<template>
  <el-select
    v-model="activeLanguage"
    class="pl-20"
    @change="changeLanguage"
  >
    <el-option
      v-for="(lang, index) in languages"
      :label="lang"
      :value="lang"
      :key="index"
    />
  </el-select>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  data: function () {
    return {
      activeLanguage: this.$i18n.locale,
      languages: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',')
    };
  },
  methods: {
    changeLanguage (locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
        this.$cookie.set('locale', locale, { expires: '1M' });
      }
    }
  }
};
</script>
